<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <span class="loading-request" v-show="loading"></span>
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">Clientes não sincronizados</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                  <div
                    v-show="!processingCustomers"
                    class="btn-group btn-group-sm"
                    role="group"
                    aria-label="Menu dos cliente"
                  >
                    <span
                      class="btn btn-outline-brand mr-2"
                      @click="confirmSyncContaAzul()"
                      v-b-tooltip.hover
                      title="Sincronizar com a Conta Azul!"
                    >
                      <i class="fas fa-sync-alt"></i>&nbsp; Criar no Conta Azul
                    </span>
                  </div>
                  <button
                    v-show="processingCustomers"
                    class="btn btn-sm btn-outline-brand"
                    disabled
                  >
                    <div class="spinner-border spinner-border-sm" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    &nbsp; Processando dados...
                  </button>
                </div>
              </div>
              <div class="page-amounts">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ selected: amount === 3 }">
                      <a @click="amount = 3" class="page-link paginate">3</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 10 }">
                      <a @click="amount = 10" class="page-link paginate">10</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 50 }">
                      <a @click="amount = 50" class="page-link paginate">50</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 100 }">
                      <a @click="amount = 100" class="page-link paginate">100</a>
                    </li>
                    <li class="page-item" :class="{ selected: amount === 150 }">
                      <a @click="amount = 150" class="page-link paginate">150</a>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="paginator-info-top m-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
            </div>
            <div class="table-responsive">
              <div class="container-table">
                <table class="table table-striped- table-bordered table-hover table-checkable">
                  <thead>
                    <tr>
                      <td class="text-center align-middle" width="20">
                        <label
                          class="m-checkbox m-checkbox--single m-checkbox--solid m-checkbox--brand mb-0 mt-0"
                          v-b-tooltip.hover
                          title="Selecionar todas faturas dessa página"
                        >
                          <input
                            type="checkbox"
                            @click="selectAllReport"
                            v-model="allSelected"
                            class="m-group-checkable"
                          />
                          <span></span>
                        </label>
                      </td>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="60"
                        @click="sortCall('id')"
                      >
                        ID Cliente
                      </td>
                      <td nowrap class="text-center align-middle" width="200">Cliente</td>
                      <td nowrap class="text-center align-middle" width="150">Documento</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(customer, id) in data.data" :key="id">
                      <td class="text-center align-middle" width="60">
                        <label
                          class="m-checkbox m-checkbox--single m-checkbox--solid m-checkbox--brand mb-0 mt-0"
                          v-b-tooltip.hover.right.title="
                            `#${customer.id} - Selecionar esse cliente`
                          "
                        >
                          <input
                            type="checkbox"
                            v-model="customerIds"
                            @click="select"
                            :value="customer.id"
                            class="m-group-checkable"
                          />
                          <span></span>
                        </label>
                      </td>
                      <td class="text-center align-middle">{{ customer.id }}</td>
                      <td class="text-left align-middle">{{ customer.customerable.name }}</td>
                      <td class="text-center align-middle">
                        {{ customer.documents ? customer.documents.value : '-' | cnpj | cpf }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page === 1 }">
                      <a class="page-link paginate" @click="page = 1"
                        ><i class="fal fa-angle-double-left"></i
                      ></a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page === 1 }">
                      <a class="page-link paginate" @click="page = data.current_page - 1"
                        ><i class="fal fa-angle-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 2">
                        {{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 1">
                        {{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate"> {{ data.current_page }} </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">
                        {{ data.current_page + 1 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 === data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 2">
                        {{ data.current_page + 2 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1"
                        ><i class="fal fa-angle-right"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page === data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.last_page"
                        ><i class="fal fa-angle-double-right"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>

      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showCustomerSave"
          @click="closeSaveCustomer()"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'CustomersExternal',
  components: {},
  data() {
    return {
      data: {},
      amount: localStorage.customerDataAmount ? localStorage.customerDataAmount : 100,
      page: localStorage.customerDataPage ? localStorage.customerDataPage : 1,
      customerIds: [],
      allSelected: false,
      processingCustomers: false,
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showCustomerSave() {
      return this.$store.state.showCustomerSave;
    },
  },
  methods: {
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
      this.callData();
    },
    clearFilters() {
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('customerExternalDataPage', this.page);
      localStorage.setItem('customerExternalDataAmount', this.amount);
    },
    convertFilters() {
      return (
        `?page=${this.page ? this.page : 1}&amount=${this.amount}&status=1` + `&external_null=1`
      );
    },
    callData() {
      this.data.current_page = 0;
      this.setStorageFilters();
      this.getDatas();
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/customer/search/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
        this.customerIds = [];
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
    selectAllReport() {
      this.customerIds = [];
      this.allSelected = !this.allSelected;
      if (this.allSelected) {
        const { data: customers } = this.data;
        customers.forEach((customer) => {
          this.customerIds.push(customer.id);
        });
      }
    },
    select() {
      this.allSelected = false;
    },
    confirmSyncContaAzul() {
      if (this.customerIds.length < 1) {
        this.$toasted.show(
          '<i class="fas fa-exclamation-triangle"></i> Nenhum cliente selecionado',
          {
            theme: 'toasted-primary',
            type: 'info',
            position: 'top-right',
            duration: 5000,
          }
        );
        return false;
      }
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Deseja enviar os dados dos clientes selecionados para o Conta Azul?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'success',
          okTitle: 'Enviar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.processingCustomers = true;
            this.syncContaAzul();
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> Dados não foram enviados',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    syncContaAzul() {
      const url = `${baseApiUrl}/v1/customer/sync/external-customer-register`;
      axios
        .post(url, { ids: this.customerIds })
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
          this.processingCustomers = false;
        })
        .catch((error) => {
          this.processingCustomers = false;
          this.logMessageFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
  },
  mounted() {
    this.getDatas();
    window.scroll(0, 0);
  },
};
</script>
